// extracted by mini-css-extract-plugin
export default {"kenoSubmitButtonWrap":"styles_kenoSubmitButtonWrap__1A6Nm","kenoSubmitButton":"styles_kenoSubmitButton__rspKF"};